export default "__VITE_ASSET__Bas$Ufhv__"